import React from 'react';

interface BlivixLogoProps {
  className?: string;
  showText?: boolean;
}

export function BlivixLogo({ className = 'w-11 h-11 sm:w-12 sm:h-12', showText = true }: BlivixLogoProps) {
  return (
    <div className="flex items-center gap-3.5 select-none">
      {/* Official AppIcon with Vibrant Glow Ring for High Visibility in Light & Dark Mode */}
      <div className="relative group cursor-pointer flex-shrink-0">
        {/* Colorful Ambient Glow Backdrop */}
        <div className="absolute -inset-1 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-2xl blur-md opacity-80 group-hover:opacity-100 transition duration-300 animate-pulse-glow" />
        
        {/* AppIcon Image */}
        <div className="relative rounded-2xl overflow-hidden ring-2 ring-indigo-500/40 dark:ring-indigo-400/50 shadow-lg shadow-indigo-500/30 bg-white dark:bg-slate-900 p-0.5">
          <img
            src="/appIcon/512.png"
            alt="Blivix Studio Pro"
            className={`${className} rounded-xl object-contain transition-transform duration-300 group-hover:scale-105`}
          />
        </div>
      </div>

      {showText && (
        <div>
          <div className="flex items-center gap-2">
            <h1 className="text-xl sm:text-2xl font-black tracking-tight bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 bg-clip-text text-transparent">
              Blivix Studio Pro
            </h1>
            <span className="px-2.5 py-0.5 rounded-full text-[10px] font-extrabold tracking-wide uppercase bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-md shadow-indigo-500/20">
              PRO
            </span>
          </div>
          <p className="text-xs font-semibold text-slate-600 dark:text-slate-400">
            High-Performance Local Image Studio • Blivix Suite
          </p>
        </div>
      )}
    </div>
  );
}
